module.exports = __webpack_public_path__ + "./kit/docs/img/big-icon-setter.d886607429ec398e4eb3f210273070e8.svg";